export interface IAppSettings {
  LOG_ROCKET_APP_NAME: string;
  IDENTITY_CLIENT_ID: string;
  IDENTITY_URL: string;
  IDENTITY_SCOPES: string;
  IDENTITY_DEBUG_LEVEL: string;
  ALLOWED_ROUTES: string;
  LEGACY_CD_URL_PROTECTED: string;
  LEGACY_CD_URL: string;
  FORCE_CLIENT_TIME: boolean;
  ROUTES_TO_HIDE_FOOTER_FOR: string;
  REFRESH_TIME: number;
}

export const AppSettings = <IAppSettings>{
  LOG_ROCKET_APP_NAME: process.env.LOG_ROCKET_APP_NAME,
  IDENTITY_CLIENT_ID: process.env.IDENTITY_CLIENT_ID,
  IDENTITY_URL: process.env.IDENTITY_URL,
  IDENTITY_SCOPES: process.env.IDENTITY_SCOPES,
  IDENTITY_DEBUG_LEVEL: process.env.IDENTITY_DEBUG_LEVEL,
  ALLOWED_ROUTES: process.env.ALLOWED_ROUTES,
  LEGACY_CD_URL_PROTECTED: `${process.env.LEGACY_CD_URL}/protected`,
  LEGACY_CD_URL: process.env.LEGACY_CD_URL,
  FORCE_CLIENT_TIME: process.env.FORCE_CLIENT_TIME === "1",
  ROUTES_TO_HIDE_FOOTER_FOR: process.env.ROUTES_TO_HIDE_FOOTER_FOR,
  REFRESH_TIME: parseInt(process.env.REFRESH_TIME),
};
